import React, { useContext, useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import LogoutIcon from '@mui/icons-material/Logout';
import WalletProviders from "./WalletProvidersNew.component";
import { AuthContext } from "../../state/context/auth.context";



const ConnectWallet = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { state, logout } = useContext(AuthContext);

  const { address, isConnected } = state.user || {};

  return (
    <>
      {isConnected ? (
        <>
          <Button variant="contained" color="secondary" size="small">
            {address.slice(0, 6)}...{address.slice(-4)}
          </Button>
          <IconButton size="small" onClick={logout} sx={{ color: "white" }}>
            <LogoutIcon fontSize="small" />
          </IconButton>
        </>
      ) : (
        <Button onClick={() => setIsOpen(true)} variant="contained" color="secondary" size="small">
          {t('common.connectWallet')}
        </Button>
      )}
      <WalletProviders open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default ConnectWallet;
